<template>
    <div>
        <el-form ref="form" :model="formModel" :rules="rules" label-width="100px">
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="原密码" prop="oldPassword">
                        <el-input v-model="formModel.oldPassword" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input v-model="formModel.newPassword" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--            <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="确认密码" prop="confirmPassword">
                                    <el-input v-model="formModel.confirmPassword" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>-->
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="handleSave">保存</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
export default {
    name: "updatePwd",
    data() {
        return {

            formModel: {},

            rules: {
                oldPassword: [
                    {required: true, message: '请输入原密码', trigger: 'change'}
                ],
                newPassword: [
                    {required: true, message: '请输入新密码', trigger: 'change'}
                ],
                /* confirmPassword: [
                     {required: true, message: '请输入确认密码', trigger: 'change'}
                 ],*/
            }
        }
    },
    methods: {
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return
                }
                this.$http.post('/users/updatePwd', this.formModel).then(res => {
                    this.$message.success('修改成功，请重新登录')
                    this.$emit('close')
                })

            })
        }
    }
}
</script>

<style scoped lang="scss">

</style>